var _defs, _g, _text;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Logo",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 142,
    height: 169,
    viewBox: "0 0 142 169",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Ellipse_28",
    "data-name": "Ellipse 28",
    cx: 71,
    cy: 71,
    r: 71,
    transform: "translate(897 10181)",
    fill: "#fafafa",
    stroke: "#fff",
    strokeWidth: 1
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_196",
    "data-name": "Path 196",
    d: "M0,0H358.991V167.529H0Z",
    transform: "translate(0 10098)",
    fill: "#16c389",
    stroke: "#707070",
    strokeWidth: 1
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_3",
    "data-name": "Mask Group 3",
    transform: "translate(-897 -10181)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_2",
    "data-name": "Mask Group 2",
    transform: "translate(789.004 83.471)",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "layer2",
    transform: "translate(116.207 10098.112)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g226",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "g421"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path815",
    d: "M713.874,722.325s-14.117,9.62-21.589,12.155-27.184,20.789-27.77,21.913a5.29,5.29,0,0,1-1.448,1.733l.433,52.321,126.125-40.46s-1.64-7.126-1.5-8.045-.615-15.327-2.89-18.174c0,0-.306-5.418-3.218-8.6s-9.136-9.5-20.358-9.778-47.78-3.068-47.78-3.068Z",
    transform: "translate(-663.067 -643.184)",
    fill: "#16c389",
    stroke: "#000",
    strokeWidth: 1.213
  }), /*#__PURE__*/React.createElement("path", {
    id: "path294",
    d: "M914.334,607.657a44.618,44.618,0,0,1,2.137,5.109c-.022.538,1.51,8.032.82,9.623s.515,2.559-1.218,4.631a14.7,14.7,0,0,0-3.405,7.774c-.68,3.789,7.66,18.543,12.8,19.867s14.7,6.854,23.153,2.5,12.7-11.547,11.774-13.829-.2-9.588-2.765-10.54l-16.442-6.108-21.214-25.069Z",
    transform: "translate(-865.967 -545.045)",
    fill: "#e9c6af",
    stroke: "#000",
    strokeWidth: 1.213
  }), /*#__PURE__*/React.createElement("path", {
    id: "path5201",
    d: "M872.131,519.058s.2,4.886.76,5.314,1.174,5.422,3.325,7.56,1.168,3.385,2.242,3.939,1.355,1.39,3.221,1.3a6.023,6.023,0,0,0,3.939-2.263c.085-.365.823,2.764.931,3.107s5.129-6.041,5.129-6.041l-6.527-17.5-11.259-.225Z",
    transform: "translate(-833.042 -474.011)",
    fill: "#e9c6af",
    stroke: "#000",
    strokeWidth: 1.213
  }), /*#__PURE__*/React.createElement("path", {
    id: "path2499",
    d: "M918.317,320.656s-.576-6.369-1.547-6.793-9.311-7.37-10.554-8.188a25.434,25.434,0,0,0-14.648-3.275c-7.552.607-7.248.394-9.068-1.213s-1.971-3.548-6.308-.607-6.217,2.79-8.613,5.7-4.489,7.4-4.125,8.977-2.82,5.52-4.246,6.763-1.092,8.947-.7,10.008c0,0,2.4,10.828,2.27,12.072,0,0,2.359-5.018,4.46-3.731s1.844.086,4.932,3.26,3.9.214,5.447,6.3,1.205,9.462,0,12.052c-1.235,2.654,1.031,9.135,2.917,12.61,1.906,3.511,13.939,14.2,17.5,14.883s4.12.695,7.034-.129,12.266-3.84,13.124-4.2h0s4.278-2.913,3.336-6.625",
    transform: "translate(-821.691 -299.055)",
    fill: "#1a1a1a",
    stroke: "#000",
    strokeWidth: 1.213
  }), /*#__PURE__*/React.createElement("path", {
    id: "path552",
    d: "M1016.913,386.93s-3.6-10.379-3.517-11.795-6.562-11.452-8.321-11.795.129-2.273-10.079-3.217-14.54,4.461-16.041,7.849,1.748,5.618,1.115,9.436c-.488,2.945-3.867,4.032-3.86,4.032s-4.032,0-3.86,5.962.12,14.045,1.93,17.628c.72,1.425,11.926,7.163,17.713,11.838,2.611,2.109,1.449,6.239,4.653,7.854,0,0,.364,1.513,2.851,3.09s9.614,1.88,12.859.273c0,0,.481.085.524-1.352s-.675-2.828-.279-4.16c.6-2.008,1.719-6.122,2.359-6.5.756-.444,1.856-5.982,2.659-7.806,0,0-.047-5.507-.714-7.054s-2-4.61-1.88-4.883-.364-2.214,1.274-3.4S1016.913,386.93,1016.913,386.93Z",
    transform: "translate(-914.518 -348.617)",
    fill: "#e9c6af",
    stroke: "#000",
    strokeWidth: 1.213
  }))))))), _text || (_text = /*#__PURE__*/React.createElement("text", {
    id: "Mitrajeet_Golsangi",
    "data-name": "Mitrajeet Golsangi",
    transform: "translate(13 166)",
    fill: "#525151",
    fontSize: 14,
    fontFamily: "Lato-Italic, Lato",
    fontStyle: "italic",
    letterSpacing: "0.043em"
  }, /*#__PURE__*/React.createElement("tspan", {
    x: 0,
    y: 0
  }, "Mitrajeet Golsangi"))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/Logo.460dbb3ef8ee1b8390a1bec66425219d.svg";
export { ForwardRef as ReactComponent };